import { isMobile } from 'react-device-detect';

const horizontalMargin = 12;
const bigHorizontalMargin = 20;
const biggerHorizontalMargin = 28;
const smallHorizontalMargin = 8;
const smallerHorizontalMargin = 4;
const smallestHorizontalMargin = 2;
const mainHorizontalMargin = horizontalMargin + smallerHorizontalMargin;
const verticalMargin = 14;
const smallVerticalMargin = 8;
const smallerVerticalMargin = 4;
const smallestVerticalMargin = 2;
const bigVerticalMargin = 18;
const biggerVerticalMargin = 30;
const biggestVerticalMargin = 40;
const opacity = 0.65;
const smallOpacity = 0.4;
const smallerOpacity = 0.22;
const extraFontSize = 40;
const biggestFontSize = 28;
const biggerFontSize = 18;
const bigFontSize = 16;
const fontSize = 14;
const smallFontSize = 13;
const smallerFontSize = 12;
const smallestFontSize = 11;
// const fontSize = '1em';
// const smallFontSize = '0.92em';
// const smallerFontSize = '0.8em';
// const smallestFontSize = '0.7em';
const primaryColor = '#2a2e2d';
const secondaryColor = '#ffc107';
const imagePlaceholderColor = '#777';
const textPlaceholderColor = '#ccc';
const buttonBackgroundPrimary = '#f0bf5f';
const buttonBackgroundSecondary = '#edd5a7';
const buttonText = '#414d30';
const buttonBorder = '#6572524b';
const cardColor = '#f7f7f7';
// const buttonBorder2 = "#606442";
const smallRadius = 4;
const radius = 6;
const lowerSoundVolume = 0.2;
const lowSoundVolume = 0.4;
const soundVolume = 0.6;
const linkColor = 'dodgerblue';
const destructiveColor = 'tomato';
const backdropColor = '#fcfcfc';
const keyboardDuration = 600;
const shakeInterval = 1800;
const modalTimer = 2000;
const maxScreenWidth = 500;
const fontFamily = 'inherit';

export const layoutDefaults = {
  horizontalMargin,
  bigHorizontalMargin,
  biggerHorizontalMargin,
  smallHorizontalMargin,
  smallerHorizontalMargin,
  smallestHorizontalMargin,
  mainHorizontalMargin,
  verticalMargin,
  smallVerticalMargin,
  smallerVerticalMargin,
  smallestVerticalMargin,
  bigVerticalMargin,
  biggerVerticalMargin,
  biggestVerticalMargin,
  opacity,
  smallOpacity,
  smallerOpacity,
  smallestFontSize,
  extraFontSize,
  biggestFontSize,
  biggerFontSize,
  bigFontSize,
  fontSize,
  smallFontSize,
  smallerFontSize,
  primaryColor,
  secondaryColor,
  imagePlaceholderColor,
  textPlaceholderColor,
  buttonBackgroundPrimary,
  buttonBackgroundSecondary,
  buttonText,
  buttonBorder,
  cardColor,
  smallRadius,
  radius,
  soundVolume,
  lowerSoundVolume,
  lowSoundVolume,
  linkColor,
  destructiveColor,
  backdropColor,
  keyboardDuration,
  shakeInterval,
  modalTimer,
  maxScreenWidth,
  fontFamily,

  fixedContainer: {
    width: '100%',
    maxWidth: isMobile ? null : maxScreenWidth,
    position: 'fixed',
    // position: "absolute",
    // alignSelf: 'center',
    // justifySelf: 'center',

    bottom: 0,
    // left: 0,
    // right: 0,
    // height: 50,
    // `max(${layoutDefaults.verticalMargin}px, env(safe-area-inset-top))`
    // marginBottom: `max(calc(env(safe-area-inset-bottom, 0px) + ${verticalMargin}px)), ${verticalMargin}px)`,
    // marginBottom: `min(${verticalMargin}px, env(safe-area-inset-bottom))`,
    marginBottom: `calc(env(safe-area-inset-bottom) + ${smallVerticalMargin}px)`,
    paddingLeft: mainHorizontalMargin,
    paddingRight: mainHorizontalMargin,
    // paddingLeft: biggerHorizontalMargin,
    // paddingRight: biggerHorizontalMargin,
    zIndex: 1,
    // border: '1px solid red',
  },
};
